import React from 'react';
import request from 'arcdynamic-request';
import {PROPERTIES} from '../../consts/tables';

function geocode(property, callback) {
	const xhr = new XMLHttpRequest();

	xhr.onload = (e)=> {
		try {
			const res = JSON.parse(e.target.response);
			callback(res.results[0].geometry.location);
		} catch (e) {
			callback(null);
		}
	};
	xhr.onerror = ()=> {callback(null)};
	xhr.open('GET', 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDjYXM4MFH059vLuf5mUgItastWFVrKzv4&address='+encodeURIComponent(`${property.ADDRESS}, ${property.CITY}, ${property.STATE}`));
	xhr.send();
}

function save(property) {
	return request(arc.path.api, {
		service: 'arcimedes',
		action: 'open.datasource.table.Data.updateByTableCode',
		params: [PROPERTIES, {
			value: [
				property,
			],
		}],
	});
}

function fetch() {
	return request(arc.path.api, {
		service: 'arcimedes',
		action: 'open.datasource.table.Data.getData',
		params: ['code', PROPERTIES, {
			column: [
				'ARCIMEDES_ROW_ID',
				'CITY',
				'STATE',
				'ADDRESS',
				'ZIP',
				'LATITUDE',
				'LONGITUDE',
			],
			limit: {
				count: 1,
				offset: 0,
			},
			filterType: 'and',
			filter: [
				{
					'text': '',
					'code': 'LATITUDE',
					'type': 'null',
				},
				{
					'text': '',
					'code': 'ADDRESS',
					'type': 'notNull',
				},
				{
					'text': '',
					'code': 'CITY',
					'type': 'notNull',
				},
				{
					'text': '',
					'code': 'STATE',
					'type': 'notNull',
				},
			],
		}],
	});
}

export default class GeoCoder extends React.Component {
    constructor(props) {
    	super(props);
        this.state = {
            isComplete: false,
            error: null,
        };

        this._crawl = this._crawl.bind(this)
    }

	_crawl() {
		fetch().then(res => {
			if (res && res.success && Array.isArray(res.data)) {
				if (res.data[0]) {
					geocode(res.data[0], (geo)=> {
						if (geo && geo.lat && geo.lng) {
							res.data[0].LATITUDE = geo.lat;
							res.data[0].LONGITUDE = geo.lng;
							save(res.data[0]).then(res => {
								if (!res.success) {
									console.error(res.message);
								}

								setTimeout(function(that){
									that._crawl();
								}, 1000);
							})
						} else {
							console.log('Could not geocode', res.data[0]);
							
							setTimeout(function(that){
								that._crawl();
							}, 1000);
						}
					})
				} else {
					this.setState({
						isComplete: true,
						error: null,
					});
				}
			} else {
				this.setState({
					error: res.message ? res.message : 'Unidentified Error',
				})
			}
		});
	}

	componentDidMount() {
		this._crawl();
	}

	render() {
		return (
			<div className='GeoCoder'>
				{
					this.state.isComplete ? <div>Finished!</div> : <div>Geocoding addresses, this may take a few minutes</div>
				}
			</div>
		);
	}
}
